import { render } from "./RecordVideo.vue?vue&type=template&id=1339be2a"
import script from "./RecordVideo.vue?vue&type=script&lang=js"
export * from "./RecordVideo.vue?vue&type=script&lang=js"

import "./RecordVideo.vue?vue&type=style&index=0&id=1339be2a&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__